import React from 'react';

import { MessageCircle } from 'react-feather';

const MessageIcon: React.FC<{}> = () => {
  return <MessageCircle style={{ color: '#F3A100' }} />;
};

export default MessageIcon;
